export const mainContentDiv = 'mainContent';
